/**
 * Datos de talleres del Colegio Bertolt Brecht
 */

export const WORKSHOPS_DATA = [
    {
        id: 'basquetbol',
        title: 'Taller de Básquetbol',
        icon: '🏀',
        description: 'El equipo del colegio entrena y compite en la cancha, representando a Bertolt Brecht con trabajo en equipo y constancia.',
        fullDescription: `El Taller de Básquetbol reúne a las y los estudiantes que quieren vivir el deporte desde la cancha del Colegio Bertolt Brecht.

En los entrenamientos y en los encuentros con otros colegios, el equipo fortalece la coordinación, el compañerismo y el compromiso de jugar con los colores de la institución. Las fotos del taller recogen al plantel en la cancha, en la preparación del grupo y en los partidos donde el colegio se presenta junto a otras escuelas.`,
        benefits: [
            'Trabajo en equipo y compañerismo',
            'Coordinación y condición física',
            'Representación del colegio en encuentros deportivos',
            'Disciplina y constancia en la cancha'
        ],
        image: '/assets/talleres/basquetbol/9c263f17-9339-4479-917a-3a4bac943ab3.jpeg',
        imageAlt: 'Equipo de básquetbol del Colegio Bertolt Brecht junto al aro',
        gallery: [
            {
                src: '/assets/talleres/basquetbol/9c263f17-9339-4479-917a-3a4bac943ab3.jpeg',
                alt: 'Plantel de básquetbol del Colegio Bertolt Brecht en un encuentro deportivo'
            },
            {
                src: '/assets/talleres/basquetbol/075af987-d593-420c-9cb9-fec6e541a879.jpeg',
                alt: 'Jugadores del equipo de básquetbol Bertolt Brecht en la cancha'
            },
            {
                src: '/assets/talleres/basquetbol/59916a54-fbbe-4d5d-9dc2-7fa47eed7a5e.jpeg',
                alt: 'Grupo del taller de básquetbol reunido antes de un encuentro'
            }
        ],
        color: 'primary'
    },
    {
        id: 'cuenta-cuentos',
        title: 'Taller de Cuenta Cuentos',
        icon: '📖',
        description: 'Niñas y niños dan vida a cuentos, fábulas y personajes en escena, con voz, gesto y vestuario.',
        fullDescription: `El Taller de Cuenta Cuentos invita a habitar las historias a través de la voz, el gesto y el vestuario.

En presentaciones como «Érase una vez…», las y los estudiantes interpretan personajes de cuentos, fábulas y relatos —desde Edipo Rey hasta los superhéroes— y comparten la escena con sus familias y la comunidad escolar. El escenario, el vestuario y la narración convierten cada función en un espacio de imaginación y expresión.`,
        benefits: [
            'Expresión oral y corporal',
            'Imaginación y creatividad',
            'Confianza al presentarse ante el público',
            'Acercamiento a los cuentos y a la narración'
        ],
        image: '/assets/talleres/cuenta-cuentos/435db6f6-dbd9-437d-b279-969f870713fd.jpeg',
        imageAlt: 'Estudiantes del taller de cuenta cuentos caracterizados en escena',
        gallery: [
            {
                src: '/assets/talleres/cuenta-cuentos/435db6f6-dbd9-437d-b279-969f870713fd.jpeg',
                alt: 'Elenco infantil caracterizado en un cuento, bajo el lema Érase una vez'
            },
            {
                src: '/assets/talleres/cuenta-cuentos/a0f7c446-9107-4ef4-9a24-b8e6b6128c4d.jpeg',
                alt: 'Presentación de Edipo Rey en el taller de cuenta cuentos'
            },
            {
                src: '/assets/talleres/cuenta-cuentos/e59e1f1b-100e-49cd-a6a2-6df2f6cc4ae8.jpeg',
                alt: 'Estudiantes caracterizados como superhéroes en el taller de cuenta cuentos'
            },
            {
                src: '/assets/talleres/cuenta-cuentos/97656ec3-dcd8-4a5e-8921-ff61633d637f.jpeg',
                alt: 'Personajes de fábulas y animales en una función del taller'
            },
            {
                src: '/assets/talleres/cuenta-cuentos/ada64065-866d-48bd-b186-e79c0a5255df.jpeg',
                alt: 'Grupo del taller de cuenta cuentos con disfraces de animales'
            },
            {
                src: '/assets/talleres/cuenta-cuentos/3f06252a-e4c5-4b5a-bf72-d1a2eeacc73a.jpeg',
                alt: 'Estudiantes y docente al cierre de una presentación de cuenta cuentos'
            }
        ],
        color: 'secondary'
    }
];

/**
 * Obtener taller por ID
 */
export const getWorkshopById = (id) => {
    return WORKSHOPS_DATA.find(workshop => workshop.id === id);
};
